import { LoadingButton } from "@mui/lab";
import { ColorButton } from "./Button";
import Footer from "./Footer";

export default function ButtonContainer({ windowDimensions, clicked, pay }) {
  return (
    <div
      style={{
        ...styles.container,
        height:
          windowDimensions.width < 1000
            ? windowDimensions.height / 10
            : windowDimensions.height / 6,
      }}
    >
      <div style={{ width: "90%", marginTop: "5%" }}>
        {clicked ? (
          <LoadingButton
            loading
            variant="outlined"
            style={
              windowDimensions.width < 1000
                ? {
                    ...styles.buttonStyle,
                    padding: "5%",
                    height: 40,
                  }
                : {
                    ...styles.buttonStyle,
                    padding: "2%",
                    height: 20,
                  }
            }
          >
            SUBMIT
          </LoadingButton>
        ) : (
          <ColorButton
            onClick={() => pay()}
            style={
              windowDimensions.width < 1000
                ? {
                    ...styles.buttonStyle,
                    padding: "5%",
                    fontSize: "1em",
                    height: 40,
                  }
                : {
                    ...styles.buttonStyle,
                    padding: "2%",
                    fontSize: "1.2em",
                    height: 20,
                  }
            }
          >
            Proceed to Pay
          </ColorButton>
        )}
      </div>
      <Footer windowDimensions={windowDimensions} />
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
  },
  buttonStyle: {
    borderRadius: 10,
    fontStyle: "Poppins",
    width: "100%",
  },
};
